import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';

import useSinglePost from '@/hooks/contentful/useSinglePost';
import { getPostValues } from '@/utils/posts';

import { CategoryChip } from '../styles';
import { dateFormat } from '../utils';
import {
  CategoriesContainer,
  Content,
  DateContainer,
  DateText,
  Imagen,
  ImageTitle,
  InfoContainer,
  InfoText,
  LoadingSkeleton,
  Title,
  TitleContainer,
} from './styles';

import type { Document, TopLevelBlock } from '@contentful/rich-text-types';

interface DetailsProps {
  idArticle: string;
}

const Details = ({ idArticle }: DetailsProps) => {
  const { t } = useTranslation();
  const { post, isLoading } = useSinglePost(idArticle);

  if (isLoading) {
    return <LoadingSkeleton sx={{ bgcolor: '#DAEDC6' }} variant="rectangular" animation="pulse" />;
  }

  if (post == null) {
    return <></>;
  }

  const postData = getPostValues(post);

  const categories = post?.fields.categories;
  const content = post?.fields.content?.content;

  return (
    <Container>
      <InfoContainer>
        <InfoText>{t('COMMON.MENU.BLOG')} •&nbsp;</InfoText>
        {postData.title}
      </InfoContainer>

      <ImageTitle>
        <TitleContainer>
          <DateContainer>
            <DateText>{dateFormat(postData.createdAt)}</DateText> &nbsp; &nbsp;
            <CategoriesContainer>
              {categories?.map((category: any) => (
                <CategoryChip
                  key={category?.sys.id}
                  label={category?.fields.categoryName}
                  variant="filled"
                  color="primary"
                  size="small"
                  sx={{ maxWidth: '5rem', marginRight: '0.4rem', marginBottom: '1rem' }}
                />
              ))}
            </CategoriesContainer>
          </DateContainer>

          <Title>{postData?.title}</Title>
        </TitleContainer>

        <Imagen prop={postData.image}></Imagen>
      </ImageTitle>

      <Content>{content?.map((el: any) => contentBlog(el))}</Content>
    </Container>
  );
};

const contentBlog = (element: TopLevelBlock) => {
  if (element?.nodeType === BLOCKS.EMBEDDED_ASSET) {
    return <img src={element?.data?.target?.fields?.file.url} alt="" />;
  }

  return documentToReactComponents(element as unknown as Document);
};

export default Details;
